import { useState, Suspense, lazy } from 'react';
import { Button } from '@mui/material';
import { Station, fetchStationData } from '../services/stationService';
import { StationSelector } from '../components/StationSelector';
import { SkiAreaTable } from '../components/SkiAreaTable';
import { SkiAreaTextData } from '../components/SkiAreaTextData';
import { useNavigate } from 'react-router-dom';

const LazyStationsSection = lazy(() => import('../components/LazyStationsSection').then(module => ({
  default: module.LazyStationsSection
})));

export function AllStationsPage() {
  const [showStations, setShowStations] = useState(false);
  const [isLoadingStations, setIsLoadingStations] = useState(false);
  const [selectedStation, setSelectedStation] = useState<Station | null>(null);
  const [skiAreaData, setSkiAreaData] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleShowStations = () => {
    if (!showStations) {
      setIsLoadingStations(true);
      setTimeout(() => {
        setIsLoadingStations(false);
        setShowStations(true);
      }, 2000);
    } else {
      setShowStations(false);
    }
  };

  const handleStationChange = async (station: Station) => {
    setSelectedStation(station);
    setError(null);
    setShowStations(false);
    try {
      const rawData = await fetchStationData(station.value);
      if (!rawData.ski_area || !rawData.metadata) {
        throw new Error('No ski area data available');
      }
      setSkiAreaData(rawData);
      // Navigate to the specific ski area page
      navigate(`/${station.routeValue}`);
    } catch (err) {
      setError('Failed to load ski area data');
      setSkiAreaData(null);
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', gap: '16px', alignItems: 'center', marginBottom: '24px' }}>
        <StationSelector
          selectedValue={selectedStation?.value}
          onStationChange={handleStationChange}
        />
      </div>
      <div className="page-content">
        {error && <div className="error">{error}</div>}
        {selectedStation && (
          <SkiAreaTextData
            stationValue={selectedStation.value}
          />
        )}
        {skiAreaData && (
          <SkiAreaTable
            data={skiAreaData}
          />
        )}
      </div>
      {skiAreaData && (
        <div style={{ marginTop: '24px', marginBottom: '24px', textAlign: 'center' }}>
          <Button
            variant="outlined"
            onClick={handleShowStations}
            disabled={isLoadingStations}
          >
            {showStations ? 'Hide Nearby Stations' : isLoadingStations ? 'Loading...' : 'Show Nearby Stations'}
          </Button>
        </div>
      )}
      {showStations && skiAreaData && (
        <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '24px' }}>Loading stations...</div>}>
          <LazyStationsSection 
            selectedStation={selectedStation}
          />
        </Suspense>
      )}
    </div>
  );
}
